<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Franchise Owner Applications'
                    : 'Deleted Franchise Applications'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3" v-if="positionName !== 'MASTER FRANCHISEE'">
                  <v-autocomplete
                    ref="zone"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.zone_id = null), (page = 1)"
                    v-model="filter.zone_id"
                    :items="zoneItems"
                    label="Zone"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Zone"
                    prepend-inner-icon="mdi-map-marker"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: 130px">
                        Requested by
                      </th>
                      <th class="text-left" style="min-width: 95px">
                        Full Name
                      </th>
                      <th class="text-left" style="min-width: none">Age</th>
                      <th class="text-left" style="min-width: none">
                        Phone No
                      </th>
                      <th class="text-left" style="min-width: none">Email</th>
                      <th class="text-left" style="min-width: none">Address</th>
                      <th class="text-left" style="min-width: none">City</th>
                      <th class="text-left" style="min-width: none">Pincode</th>
                      <th class="text-left" style="min-width: none">Gender</th>
                      <th class="text-left" style="min-width: none">Zone</th>
                      <th class="text-left" style="min-width: none">
                        Applying as
                      </th>
                      <th class="text-left" style="min-width: 175px">
                        Currently Own/Operate any business
                      </th>
                      <th class="text-left" style="min-width: none">
                        Business Details
                      </th>
                      <th class="text-left" style="min-width: 138px">
                        Ran a Franchisee business
                      </th>
                      <th class="text-left" style="min-width: none">
                        Franchisee business details
                      </th>
                      <th class="text-left" style="min-width: 127px">
                        Has Experience in Pet Industry
                      </th>
                      <th class="text-left" style="min-width: 160px">
                        Proposed Franchisee Location
                      </th>
                      <th class="text-left" style="min-width: none">
                        Support & Interest
                      </th>
                      <th class="text-left" style="min-width: 105px">
                        Heard from
                      </th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="franchisee_career_requests.length != 0">
                    <tr
                      v-for="(
                        franchisee_career_request, i
                      ) in franchisee_career_requests"
                      :key="`franchisee_career_request_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last':
                          franchisee_career_requests.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="franchisee_career_request.status == 1"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>Request has been approved</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="franchisee_career_request.status == 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Waiting for Approval</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="franchisee_career_request.status == 2"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Request has been rejected</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{
                          franchisee_career_request.request_by.user_name || ""
                        }}
                      </td>
                      <td>{{ franchisee_career_request.full_name || "" }}</td>
                      <td>{{ franchisee_career_request.age || "" }}</td>
                      <td>{{ franchisee_career_request.phone_no || "" }}</td>
                      <td>{{ franchisee_career_request.email || "" }}</td>
                      <td style="min-width: 130px">
                        {{ franchisee_career_request.address || "" }}
                      </td>
                      <td>{{ franchisee_career_request.city || "" }}</td>
                      <td>{{ franchisee_career_request.pin_code || "" }}</td>
                      <td>
                        {{
                          franchisee_career_request.gender != "2"
                            ? franchisee_career_request.gender == "0"
                              ? "MALE"
                              : "FEMALE"
                            : "OTHER" || ""
                        }}
                      </td>
                      <td style="min-width: 155px">
                        <v-select
                          v-if="positionName !== 'MASTER FRANCHISEE'"
                          :items="zoneItems"
                          item-text="text"
                          item-value="value"
                          v-model="franchisee_career_request.zone_id"
                          @change="updateZone(franchisee_career_request)"
                          dense
                          outlined
                          hide-details
                        ></v-select>
                        <span v-else>
                          {{ getZoneName(franchisee_career_request.zone_id) }}
                        </span>
                      </td>
                      <td>
                        {{
                          franchisee_career_request.applying_as != "2"
                            ? franchisee_career_request.applying_as == "1"
                              ? "PARTNERSHIP"
                              : "INDIVIDUAL"
                            : "COMPANY" || ""
                        }}
                      </td>
                      <td>
                        {{
                          franchisee_career_request.currently_operate_business ==
                          "1"
                            ? "YES"
                            : "NO" || ""
                        }}
                      </td>
                      <td style="min-width: 255px">
                        <template
                          v-if="
                            franchisee_career_request.business_description
                              ?.length > 85
                          "
                        >
                          <v-tooltip bottom allow-overflow="false">
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{
                                  franchisee_career_request.business_description
                                    ?.length > 85
                                    ? franchisee_career_request.business_description.slice(
                                        0,
                                        85,
                                      ) + "..."
                                    : franchisee_career_request.business_description
                                }}
                              </span>
                            </template>
                            <span>{{
                              franchisee_career_request.business_description
                            }}</span>
                          </v-tooltip></template
                        >
                        <template v-else>
                          {{ franchisee_career_request.business_description }}
                        </template>
                      </td>
                      <td>
                        {{
                          franchisee_career_request.has_franchisee_business ||
                          ""
                        }}
                      </td>
                      <td style="min-width: 265px">
                        <template
                          v-if="
                            franchisee_career_request.franchisee_description
                              ?.length > 85
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{
                                  franchisee_career_request
                                    .franchisee_description?.length > 85
                                    ? franchisee_career_request.franchisee_description.slice(
                                        0,
                                        85,
                                      ) + "..."
                                    : franchisee_career_request.franchisee_description
                                }}
                              </span>
                            </template>
                            <span>{{
                              franchisee_career_request.franchisee_description
                            }}</span>
                          </v-tooltip></template
                        >
                        <template v-else>
                          {{ franchisee_career_request.franchisee_description }}
                        </template>
                      </td>
                      <td>
                        {{
                          franchisee_career_request.is_experienced_pet_industry ||
                          ""
                        }}
                      </td>
                      <td>
                        {{
                          franchisee_career_request.proposed_franchisee_location ||
                          ""
                        }}
                      </td>
                      <td style="min-width: 255px">
                        <template
                          v-if="
                            franchisee_career_request.support_interest?.length >
                            85
                          "
                        >
                          <v-tooltip bottom allow-overflow="false">
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{
                                  franchisee_career_request.support_interest
                                    ?.length > 85
                                    ? franchisee_career_request.support_interest.slice(
                                        0,
                                        85,
                                      ) + "..."
                                    : franchisee_career_request.support_interest
                                }}
                              </span>
                            </template>
                            <span>{{
                              franchisee_career_request.support_interest
                            }}</span>
                          </v-tooltip></template
                        >
                        <template v-else>
                          {{ franchisee_career_request.support_interest }}
                        </template>
                      </td>
                      <td>
                        {{ franchisee_career_request.heard_from || "" }}
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(franchisee_career_request.created_at) }}
                      </td>
                      <td class="text-right" style="min-width: 155px">
                        <v-btn v-can:edit="'franchise_owner_requests'"
                          v-if="franchisee_career_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="success"
                          @click="updateStatus(franchisee_career_request.id, 1)"
                        >
                          <v-icon dark>mdi-check</v-icon>
                        </v-btn>
                        <!-- Reject button (only show if status is 0) -->
                        <v-btn v-can:edit="'franchise_owner_requests'"
                          v-if="franchisee_career_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="error"
                          @click="updateStatus(franchisee_career_request.id, 2)"
                        >
                          <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="primary"
                                :to="`/franchisee-career-requests/${encryptIt(
                                  franchisee_career_request.id,
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this request</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'franchise_owner_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="error"
                                @click="
                                  OpenWarning(franchisee_career_request.id)
                                "
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Request</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'franchise_owner_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="
                                  Restore_this(franchisee_career_request.id)
                                "
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this franchisee_career_request</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Status Change Warning Dialog Box -->
      <v-dialog v-model="show_Warning_popUp" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>
                        Are you sure to
                        {{
                          selected_requested.status == "1"
                            ? "Approve"
                            : "Reject"
                        }}?.
                      </h3>
                      <br />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-can:edit="'franchise_owner_requests'"
                        color="success"
                        @click="
                          (show_Warning_popUp = false),
                            confirmUpdate(selected_requested)
                        "
                      >
                        Confirm
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="red"
                        dark
                        @click="
                          (show_Warning_popUp = false),
                            (selected_requested = {})
                        "
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_franchisee_career_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>FranchiseeCareerRequest deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_franchisee_career_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_franchisee_career_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>FranchiseeCareerRequest restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_franchisee_career_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "FranchiseeCareerRequestsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
        zone_id: "",
      },
      franchisee_career_requests: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      zoneItems: [],
      ExportFranchiseeCareerRequestTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isMasterLoading: false,
      isExcelloading: false,
      delete_franchisee_career_request: false,
      is_deleted_franchisee_career_request: false,
      restore_franchisee_career_request: false,
      is_restored_franchisee_career_request: false,
      show_Warning_popUp: false,
      is_confirmed_delete: "",
      to_be_deleted_id: "",
      deleteDialog: "",
      selected_requested: {},
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    async getMasters() {
      this.isMasterLoading = true;
      await axios
        .get(`masters?context=franchisee_career_requests`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.zones.forEach((zone) => {
            this.zoneItems.push({
              id: zone.id,
              text: zone.description,
              value: zone.id,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
    },
    OpenWarning(request_id) {
      console.log("Show Warning");
      this.is_confirmed_delete = false;
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    updateStatus(id, status) {
      this.selected_requested = {
        id: id,
        status: status,
      };
      this.show_Warning_popUp = true;
    },
    validationMessage(error) {
      const errors = error.response?.data?.errors;
      if (!errors) return null;
      return Object.values(errors).flat().join(" ");
    },
    async confirmUpdate(selected_requested) {
      let reqID = this.encryptIt(selected_requested.id);

      try {
        await axios.patch(
          `/franchisee_career_requests/${reqID}`,
          selected_requested,
        );
        this.getData();
      } catch (error) {
        const message = this.validationMessage(error);
        if (message) {
          this.isShowPopUP("Cannot approve", message, "error");
        } else {
          console.error(error);
          this.isUnAuthorised();
        }
      }
      this.show_Warning_popUp = false;
    },
    getZoneName(zoneId) {
      if (!zoneId) return "";
      const zone = this.zoneItems.find((item) => item.value == zoneId);
      return zone ? zone.text : "";
    },
    async updateZone(franchisee_career_request) {
      try {
        const reqID = this.encryptIt(franchisee_career_request.id);
        const payload = {
          zone_id: franchisee_career_request.zone_id,
        };

        await axios.patch(`/franchisee_career_requests/${reqID}`, payload);
        this.isShowPopUP("Success", "Zone updated successfully", "success");
      } catch (error) {
        const message = this.validationMessage(error);
        if (message) {
          this.isShowPopUP("Could not save", message, "error");
        } else {
          console.error(error);
          this.isUnAuthorised();
        }
      }
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.zone_id = this.filter.zone_id ? this.filter.zone_id : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword +
        (this.filter.zone_id ? "&zone_id=" + this.filter.zone_id : "");

      await axios
        .get(`franchisee_career_requests?${query}`)
        .then((response) => {
          this.franchisee_career_requests = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(
        `franchisee_career_request_exports?${query}`,
      );
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_franchisee_career_request = true;
      await axios
        .post(`/franchisee_career_requests/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_franchisee_career_request = false;
          this.is_deleted_franchisee_career_request = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async Restore_this(id) {
      this.restore_franchisee_career_request = true;
      await axios
        .post(`/franchisee_career_requests/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_franchisee_career_request = false;
          this.is_restored_franchisee_career_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
  },
};
</script>
